var map = {
	"./MaskGroup2.jpg": 14,
	"./MaskGroup2@2x.jpg": 42,
	"./blue.jpg": 25,
	"./blue@2x.jpg": 43,
	"./jean-philippe-delberghe.jpg": 16,
	"./john-jennings.jpg": 15,
	"./meteor-dribbble-1.jpg": 44,
	"./meteor-dribbble-2.jpg": 45,
	"./meteor-dribbble-3.jpg": 46,
	"./meteor-dribbble-4.jpg": 47,
	"./meteor-dribbble-5.jpg": 48,
	"./meteor-dribbble.jpg": 49,
	"./purple.jpg": 26,
	"./purple@2x.jpg": 50,
	"./undraw_teacher.svg": 51,
	"./yellow.jpg": 24,
	"./yellow@2x.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;